export const gtmSearchProductItemClickEvent = (productGtmData: any, position: number) => {
  return {
    event: 'select_item',
    ecommerce: {
      actionFields: null, /// ????
      products: {
        id: productGtmData.id,
        family_id: null, // ?????
        name: productGtmData.name,
        publicDesignId: productGtmData.publicDesignId,
        customerDesignId: productGtmData.customerDesignId,
        designIdEncLocale: productGtmData.designIdEncLocale,
        category: productGtmData.category,
        brand: productGtmData.brand,
        marketing_material: productGtmData.marketing_material,
        price: productGtmData.price,
        priceEUR: productGtmData.priceEUR,
        dimension1: productGtmData.dimension1,
        dimension2: productGtmData.dimension2,
        dimension3: productGtmData.dimension3,
        position,
        list: productGtmData.list, // ??????
      },
    },
  };
};

export default gtmSearchProductItemClickEvent;
